$ = jQuery;

jQuery(document).ready(function () {
    sticky();
    teamAccordion();
    burgerMenu();
    scroll();
    // checkPosition();
    resize();
    // $(window).resize(resize);

    headerOffset();
});

function burgerMenu() {
    $('.burger-menu').click(function () {
        $('body').toggleClass('no-scroll');
        $('.overlay').toggleClass('open');
        $(this).toggleClass('burger-menu--open');
        $(this).siblings('ul.menu').toggleClass('open');
    });
    $('.overlay').click(function () {
        $('body').removeClass('no-scroll');
        $(this).removeClass('open');
        $('.burger-menu').removeClass('burger-menu--open');
        $('.burger-menu').siblings('ul.menu').removeClass('open');
    })

}

function sticky() {
    $(window).scroll(function () {
        var height = $(window).scrollTop();
        var head_height = $('header.site_header').height();
        var head_height_show = $('header.site_header').height();
        if (height > head_height_show) {
            $('header.site_header').addClass('header-fixed');
        } else {
            $('header.site_header').removeClass('header-fixed');
        }
    });
}

function headerOffset() {
    var h_offset = $('header.site_header').height();
    // $('.header-offset').css('height' h_offset + 'px');
    if ($('body').hasClass('admin-bar')) {
        $('.header-offset').css('height', h_offset + 32);
    } else {
        $('.header-offset').css('height', h_offset);
    }
}

function teamAccordion() {
    $('.accordion').on('click', function () {
        $(this).find('.content').slideToggle(100);
        $(this).find('span').toggleClass('down');
    })
}



window.hashName = window.location.hash; //ложим в переменную
window.location.hash = ''; //очищаем хэш
if (window.hashName[1] != undefined) { //проверяем
    $('html, body').animate({
        scrollTop: $(window.hashName).offset().top + 50
    }, 1000);
};

function scroll() {

    // $(".page_links").on("click", "a", function (event) {
    //     event.preventDefault();
    //     var id = $(this).attr('href'),
    //         top = $(id).offset().top - 150;
    //     if (screen.width < 768) {
    //         top = $(id).offset().top - 120;
    //     }
    //     $('body,html').animate({
    //         scrollTop: top
    //     }, 1500);

    // });


    $('a[href*="#"]')
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {

            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
                location.hostname == this.hostname
            ) {

                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                if (target.length) {

                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - 50

                    }, 1000, function () {
                        // Callback after animation
                        // Must change focus!
                        // var $target = $(target);
                        // $target.focus();
                        // if ($target.is(":focus")) { // Checking if the target was focused
                        //     return true;
                        // } 
                        // else {
                        //     $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                        //     $target.focus(); // Set focus again
                        // };
                    });
                }
            }
        });

    // $("#menu-item-342, #menu-item-343").on("click","a", function (event) {
    // 	event.preventDefault();
    // 	var id  = $(this).attr('href'),
    // 		top = $(id).offset().top;
    // 	$('body,html').animate({scrollTop: top}, 1500);
    // });

}

function resize() {
    if (window.innerWidth <= 1025) {
        $('ul.menu li > ul.sub-menu').parent().on('click', function () {
            var submenu = $(this).children('ul.sub-menu');
            if ($(submenu).is(':hidden')) {
                $(submenu).slideDown(200);
            } else {
                $(submenu).slideUp(200);
            }
        });
    }
}
